/**
 * 모바일 뷰포트 감지 mixin (#732)
 *
 * 사용처: ViewerHeaderBasic.vue 등 뷰포트 너비에 따라 모바일/데스크탑 분기가
 * 필요한 컴포넌트.
 *
 * 배경
 *  store의 `isMobile` getter는 UA + (innerWidth ≤ 768 && touch) 조합이라
 *  데스크탑 브라우저를 좁게 줄였을 때를 잡지 못한다. 반면 뷰포트 너비만으로
 *  분기해야 하는 UI(드롭다운, 모바일 전용 레이아웃)가 다수 존재하며 동일한
 *  resize 리스너 패턴이 코드베이스 여러 곳에 중복되어 있어 mixin으로 추출한다.
 *
 * 동작
 *  - mounted 시 1회 + resize 이벤트마다 `window.innerWidth < 992` 평가
 *  - lodash.throttle(150)로 매 프레임 호출 폭주 방지
 *  - beforeDestroy에서 리스너 해제 + throttle 큐 cancel
 *
 * 명명 규칙
 *  - mixin 전용 핸들러는 Vue 공식 가이드에 따라 `$_mobileViewport_` 네임스페이스
 *    prefix 사용
 *
 * 기준값
 *  - 992 (Bootstrap lg). 이 값 미만이면 b-navbar(`toggleable="lg"`)의 collapse
 *    동작이 발생하고, 대부분의 모바일/태블릿 포트레이트가 여기 해당.
 */
import throttle from 'lodash/throttle';

const MOBILE_BREAKPOINT = 992;

export default {
  data() {
    return {
      isMobileViewport: false
    };
  },
  mounted() {
    this.checkMobileViewport();
    this.$_mobileViewport_handler = throttle(this.checkMobileViewport, 150);
    window.addEventListener('resize', this.$_mobileViewport_handler);
  },
  beforeDestroy() {
    if (this.$_mobileViewport_handler) {
      window.removeEventListener('resize', this.$_mobileViewport_handler);
      this.$_mobileViewport_handler.cancel();
      this.$_mobileViewport_handler = null;
    }
  },
  methods: {
    checkMobileViewport() {
      this.isMobileViewport = window.innerWidth < MOBILE_BREAKPOINT;
    }
  }
};
